module.exports = __webpack_public_path__ + "officialStatic/img/xyfb.98693e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/xyfb.png
// module id = 5WAT
// module chunks = 0